export const BLOGS_DATA = [
  {
    id: "1",
    blogId: "check-the-safest-and-surest-way-to-check-loose-dropping-in-poultry",
    img: "/img/blogs/blog_1.png",
    title: "CHECK® - THE SAFEST AND SUREST WAY TO CHECK LOOSE DROPPING IN POULTRY",
    intro: `Loose droppings, or diarrhoea, are among the most common and concerning issues in poultry farming.
    They not only affect bird comfort but also reduce productivity, increase mortality risk, and raise treatment costs.
    Diarrhea is not a disease itself; it is a symptom that can arise due to several reasons:`,

    reasons: [
      {
        label: "Nutritional factors",
        text: "sudden changes in diet, poor-quality feed, or an imbalance in nutrients.",
      },
      {
        label: "Infectious causes",
        text: "bacterial, viral, or parasitic infections such as E. coli, Salmonella, or coccidiosis.",
      },
      {
        label: "Antibiotic-induced imbalance",
        text: "prolonged or excessive use of antibiotics disturbs the natural gut flora.",
      },
      {
        label: "Environmental stress",
        text: "poor hygiene, contaminated water, and over-specialized extreme temperatures.",
      },
      {
        label: "Hormonal or metabolic issues",
        text: "relatively rare but require specialized veterinary care.",
      },
    ],

    subHeading: "Why Antibiotics Are Not the Best Solution",

    antibioticsIntro: `For decades, antibiotics have been the go-to treatment for controlling diarrhea. While they may
    suppress harmful bacteria temporarily, their disadvantages outweigh the benefits:`,

    antibioticPoints: [
      "Kill both harmful and beneficial bacteria, thereby disrupting the natural balance of the gut.",
      "Reduce feed intake and growth due to stress on the digestive system.",
      "Weaken long-term resistance, leaving birds prone to repeat infections.",
      "Raise concerns about residues in meat and eggs, which impact food safety and consumer trust.",
    ],

    conclusion: `Given the drawbacks of antibiotics, there is a pressing need for safe, fast-acting, and antibiotic-free alternatives.
    This is not just a preference, but a necessity for the health and productivity of your flock.`,
    
    highlightone: `CHECK® is a specially formulated probiotics-based, natural, safe product that provides
        rapid and reliable control of diarrhoea in poultry without side effects in less than 6 hours.
        It helps restore gut health and flock productivity, regardless of the cause, whether infectious, nutritional,
        or antibiotic induced (except in cases involving hormonal imbalance, which is necessary for growth).`,
    

    highlighttwo: {
      intro: `CHECK® is a specially formulated probiotics-based, natural, safe product that provides rapid and reliable control of diarrhoea in poultry without side effects in less than 6 hours. It helps restore gut health and flock productivity, regardless of the cause, whether infectious, nutritional, or antibiotic induced (except in cases involving hormonal imbalance, which is necessary for growth).`,
      multiTargetApproach: [
        "Restoring gut microbial balance with beneficial probiotics.",
        "Neutralising bacterial toxins and preventing further intestinal damage.",
        "Flushing out harmful pathogens through binding action.",
        "Activating the immune system to resist infections and improve resilience.",
        "Providing quick energy to support faster recovery.",
      ],
      combinedAction: `This combined action ensures that diarrhoea - whether due to infection, feed imbalance, or antibiotic side effects - is controlled safely, rapidly, and without the drawbacks of antibiotics.`,
      benefits: [
        "Fast action without negative side effects.",
        "Improves digestion and feed conversion ratio (FCR).",
        "Reduces inflammation and pathogen load.",
        "Protects the gastrointestinal and respiratory tracts.",
        "Boosts non-specific immunity for long-term resistance.",
        "Safe for preventive use at regular intervals.",
        "100% free from antibiotics and chemical residues.",
      ],
      dosage: [
        "Dosage: 200g of CHECK® for 5000 chicks/broilers/layers/breeders.",
        "Administer in the first water or feed of the day at the first sign of loose droppings.",
        "Preferably given through water; if water sanitisers are used, mix them in with the feed instead. Ensure uniform and thorough mixing.",
        "Dosage may be adjusted depending on flock conditions and veterinary advice.",
      ],
      presentation: [
        "200g multilayer food-grade aluminum packs with a duplex carton box and bulk pails available for larger farm use.",
      ],
      conclusion: [
        "Antibiotics can be effective in managing loose droppings; however, they may also harm gut health and decrease productivity. Fortunately, CHECK® offers a natural, safe probiotics formulation, an antibiotic-free solution that is scientifically proven to work quickly. It boosts immunity, reduces mortality, improves dry matter retention, and enhances the overall wellness of your flock. Embrace a healthier approach today."
      ],
    },
  },
  {
    id: "2",
    blogId: "biofence-stage-I-day-old-chick-spray",
    img: "/img/blogs/blog_2_card.png",
    title: "BIOFENCE® STAGE-I",
    subTitle: "Day old chick spray for Maximum Liveability, Immunity and Growth",
    content: [
      {
        type: "paragraph",
        text: "Hatcheries for chicks provide controlled conditions, including optimal temperature, humidity, and biosecurity. Chicks leaving the hatchery face a sudden and profound challenge. The move out exposes them to multiple stressors, including drastic changes in environmental parameters (temperature, humidity, and lighting), stacking, and a critical period of no external feed and water during transportation.",
      },
      {
        type: "paragraph",
        text: "Chicks after hatching have a sterile gut, with remnants of yolk found on their body, which serve as a good nutritional source. Moving out of the hatchery, chicks are susceptible to pathogen contamination, which affects their gut habitat and can potentially lead to serious infections and high mortality rates. These opportunistic pathogens quickly colonise the gut, impacting health and severely compromising long-term performance, leading to mortality.",
      },
      {
        type: "paragraph",
        text: "Recognising this critical window for initial gut stabilisation, INTRON's R&D division has developed BIOFENCE® STAGE-I. This is the world's first TRIBIOTIC® - a groundbreaking, scientifically formulated solution that combines prebiotics, probiotics, and postbiotics to deliver comprehensive and early-life protection.",
      
      },
      {
        type: "image",
        src: "/img/blogs/blog_2_img.png",
        alt: "BIOFENCE® STAGE-I",
        width: "60%",
        height: "300px",
      },
      {
        type: "paragraph",
        text: "The unique TRIBIOTC® works individually and in synergy, promoting better gut health, supporting nutrient absorption, and improving growth and disease resistance immediately after hatching. This helps chicks start strong with improved overall health and performance.",
      },
      {
        type: "paragraph",
        text: "The application of BIOFENCE® STAGE-I has demonstrated significant improvements in poultry growth, health and performance, notably reducing chick mortality and promoting improved chick movement and uniformity across the flock.",
      },
      {
        type: "image",
        src: "/img/blogs/blog_2.png",
        alt: "BIOFENCE® STAGE-I",
      },
      {
        type: "heading",
        text: "The Smart Spray: Leveraging the Natural Preening Reflex",
      },
      {
        type: "paragraph",
        text: "The delivery method of BIOFENCE® STAGE-I is simple. Mix 100 grams of the product in 3-4 L of plain, additive-free water (excluding antibiotics, feed supplements, or sanitisers) to make an orange-coloured viscous liquid. This solution is then sprayed on the chicks in the hatchery or on the farm immediately upon arrival. BIOFENCE® STAGE-I, upon mixing water, forms a thick solution, and this can be used as supplemental feed during the transportation of chicks. Crucially, the proprietary orange colour naturally attracts the chicks and stimulates the preening reflex.",
      },
      {
        type: "paragraph",
        text: "As they preen, the formulation is seamlessly transferred from feather to beak, ensuring the probiotics are ingested for effective gut colonisation and also takes advantage of the yolk residues on the chick's body to outcompete the pathogens.",
      },
      {
        type: "list",
        title: "Key Benefits of BIOFENCE® STAGE-I",
        items: [
          "Helps the birds establish initial gut microbiota",
          "Protects against colonisation of harmful and pathogenic microorganisms on the bird's body, utilizing residues from hatching eggs instead utilizes the residues to establish a friendly, useful probiotic microbiota",
          "Helps the chicks attain better and faster gut integrity",
          "Improves the overall immunity status of the chicks for a great start",
          "Acts as a supplemental feed and enhances digestion and FCR",
          "Improves flock liveability",
          "Reduces the risk of disease",
          "infections and the need for frequent medication",
        ],
      },
      {
        type: "heading",
        text: "Practical, Safe, and Cost-Effective Integration",
      },
      {
        type: "paragraph",
        text: "BIOFENCE® STAGE-I is available in practical 10g sachets for 1000 chicks, 100g tins with TOSSPACK for 10,000 chicks, and bulk pails. Its simple preparation and natural, stress-free delivery method (basic sprayers instead of costly & complicated applicators) ensure uniform microbial exposure across the largest batches of chicks.",
      },
      {
        type: "video",
        src: "/img/video/video_1.mp4",
        height: "400px",
      },
      {
        type: "heading",
        text: "Conclusion",
      },
      {
        type: "conclusion-paragraph",
        text: "BIOFENCE® STAGE-I represents a fundamental shift in early life poultry care - a remarkable fusion of advanced scientific TRIBIOTIC™ technology and an understanding of innate chick instincts. By guaranteeing stronger immunity and enhancing performance from the first hour, INTRON sets a new industry benchmark for healthier, more sustainable poultry production.",
      },
    ],
  },
  // Add more blogs as needed...
];